import { jsx as i } from "react/jsx-runtime";
import { useId as y, Children as m, cloneElement as p } from "react";
import { tv as f } from "tailwind-variants";
const u = f({
  base: ["flex", "flex-col", "gap-2"]
}), c = ({ children: a, className: n }) => {
  const t = y(), s = m.toArray(a).some((e) => {
    var r;
    return ((r = e.type) == null ? void 0 : r.displayName) === "HelperText";
  }) ? `${t}-help` : void 0;
  return /* @__PURE__ */ i("div", { className: u({ class: n }), children: m.map(a, (e) => {
    var r, o, l;
    return ((r = e.type) == null ? void 0 : r.displayName) === "Label" ? p(e, { htmlFor: t }) : ((o = e.type) == null ? void 0 : o.displayName) === "HelperText" ? p(e, { id: s }) : ((l = e.type) == null ? void 0 : l.displayName) === "InputWrapper" ? p(e, { id: t, ariaDescribedby: s }) : e;
  }) });
};
export {
  c as default
};
